class ChiefComplaintAdvices {
  constructor(note, priority, chiefComplaintId) {
    this.note = note;
    this.priority = priority;
    this.chiefComplaintId = chiefComplaintId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allChiefComplaintAdvices: [],
      chiefComplaintAdvice: new ChiefComplaintAdvices('', null, null),
      allClinicalTriagessForOther: [],
    };
  },
  methods: {
    // TODO immidiatly check it about getListOfClinicalTriagesForOther
    getListOfClinicalTriagesForOther: function (chiefCompliantId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllClinicalTriages', Number(chiefCompliantId)).then(() => {
        if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
          this.allClinicalTriagessForOther =
            this.$store.state.chiefComplaintAdviceModule.allChiefComplaintAdvices;
          if (this.formLoad) {
            this.compliantClinicalTriageList = this.allClinicalTriagessForOther;
            this.compliantClinicalTriageList.forEach((c) => {
              c.isSelected = false;
              c.isDisable = false;
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfClinicalTriagesForOther(chiefCompliantId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfClinicalTriagesForOther(chiefCompliantId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllChiefComplaintAdvices: function (chiefComplaintId) {
      this.load.val = true;
      const params = {
        chiefComplaintId,
      };
      this.$store
        .dispatch('getAllChiefComplaintTechnicianAdvicesDispatch', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
            const data =
              this.$store.state.chiefComplaintAdviceModule.allChiefComplaintTechnicianAdvices;
            this.allChiefComplaintAdvices = this.transformAdvicesList(data);
          } else {
            if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllChiefComplaintAdvices(chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllChiefComplaintAdvices(chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    resetChiefComplaintAdviceBody: function () {
      this.chiefComplaintAdvice = new ChiefComplaintAdvices('', null, null);
    },
    setAddBody: function () {
      const body = {
        chiefComplaintId: this.chiefComplaintId,
        priority: Number(this.chiefComplaintAdvice.priority),
        note: this.chiefComplaintAdvice.note,
      };
      return body;
    },
    setEditBody: function () {
      const body = {
        chiefComplaintId: this.chiefComplaintId,
        priority: Number(this.chiefComplaintAdvice.priority),
        note: this.chiefComplaintAdvice.note,
        id: this.chiefComplaintAdvice.id,
      };
      return body;
    },
    addChiefCompaintAdvice: function () {
      if (this.onValidate()) {
        const body = this.setAddBody();
        this.load.val = true;
        this.$store
          .dispatch('addChiefComplaintTechnicianAdviceDispatch', body)
          .then(() => {
            if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
              this.$refs.confirm.showConfirmDialog = false;
              this.showAddEditModal = false;
              this.disabelConfirm = false;
              this.showSuccessAlert('تریاژ بالینی با موفقیت اضافه شد');
              this.resetChiefComplaintAdviceBody();
              this.getAllChiefComplaintAdvices(this.chiefComplaintId);
            } else {
              this.disabelConfirm = false;
              if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
                this.$store.dispatch('refreshToken').then(() => {
                  if (this.$store.state.userModule.successFlag) {
                    this.addChiefCompaintAdvice();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
                this.$store.dispatch('csrf').then(() => {
                  if (this.$store.state.loginModule.successFlag) {
                    this.addChiefCompaintAdvice();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else {
                this.showError();
              }
            }
          })
          .finally(() => {
            this.load.val = false;
          });
      }
    },
    setChiefComplaintAdvice: function (data) {
      this.chiefComplaintAdvice.id = data.id;
      this.chiefComplaintAdvice.note = data.note;
      this.chiefComplaintAdvice.priority = data.priority;
      this.chiefComplaintAdvice.chiefComplaintId = this.chiefComplaintId;
    },
    getChiefComplaintAdvice: function (chiefComplaintTechnicianAdviceId) {
      const params = {
        chiefComplaintTechnicianAdviceId,
      };
      this.load.val = true;

      this.$store
        .dispatch('getChiefComplaintTechnicianAdviceDispatch', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
            const data =
              this.$store.state.chiefComplaintAdviceModule.chiefComplaintTechnicianAdvice;
            this.setChiefComplaintAdvice(data);
          } else {
            if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getChiefComplaintAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getChiefComplaintAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    editChiefComplaintAdvice: function () {
      if (this.onValidate()) {
        this.setEditBody();
        this.load.val = true;
        this.$store
          .dispatch('editChiefComplaintTechnicianAdviceDispatch', this.chiefComplaintAdvice)
          .then(() => {
            if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
              this.getAllChiefComplaintAdvices(this.chiefComplaintId);
              this.showSuccessAlert('تریاژ بالینی با موفقیت ویرایش شد.');
              this.$refs.confirm.showConfirmDialog = false;
              this.disabelConfirm = false;
              this.showAddEditModal = false;
              this.resetChiefComplaintAdviceBody();
            } else {
              this.disabelConfirm = false;
              if (this.load.val) {
                this.load.val = false;
              }
              if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
                this.$store.dispatch('refreshToken').then(() => {
                  if (this.$store.state.userModule.successFlag) {
                    this.editClinicalTriagesFunction();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
                this.$store.dispatch('csrf').then(() => {
                  if (this.$store.state.loginModule.successFlag) {
                    this.editClinicalTriagesFunction();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else {
                this.showError();
              }
            }
          });
      }
    },
    deleteChiefComplaintAdvice: function (chiefComplaintTechnicianAdviceId) {
      const params = {
        chiefComplaintTechnicianAdviceId,
      };
      this.load.val = true;
      this.$store
        .dispatch('deleteChiefComplaintTechnicianAdviceDispatch', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getAllChiefComplaintAdvices(this.chiefComplaintId);
            this.showSuccessAlert('تریاژ بالینی با موفقیت حذف شد');
          } else {
            this.disabelConfirm = false;
            if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deleteChiefComplaintAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deleteChiefComplaintAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    deactivateChiefComplaintTechnicianAdvice: function (chiefComplaintTechnicianAdviceId) {
      const params = {
        chiefComplaintTechnicianAdviceId,
      };
      this.load.val = true;
      this.$store
        .dispatch('deactiveChiefComplaintTechnicianAdviceDispatch', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getAllChiefComplaintAdvices(this.chiefComplaintId);
            this.showSuccessAlert('تریاژ بالینی با موفقیت غیرفعال شد');
          } else {
            this.disabelConfirm = false;
            if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deactivateChiefComplaintTechnicianAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deactivateChiefComplaintTechnicianAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    activateChiefComplaintTechnicianAdvice: function (chiefComplaintTechnicianAdviceId) {
      const params = {
        chiefComplaintTechnicianAdviceId,
      };
      this.load.val = true;
      this.$store
        .dispatch('activeChiefComplaintTechnicianAdviceDispatch', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAdviceModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getAllChiefComplaintAdvices(this.chiefComplaintId);
            this.showSuccessAlert('تریاژ بالینی با موفقیت فعال شد');
          } else {
            this.disabelConfirm = false;
            if (this.$store.state.chiefComplaintAdviceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.activateChiefComplaintTechnicianAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAdviceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.activateChiefComplaintTechnicianAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    showError: function () {
      this.snackText = this.$store.state.chiefComplaintAdviceModule.error;
      this.showErrorAlert(this.snackText);
    },
  },

  computed: {
    clinicalTriagepriority() {
      return Array.from(
        { length: this.allChiefComplaintAdvices.length + 1 },
        (_, index) => index + 1,
      );
    },
  },
};
